<sb-card [loading]="loading">
  <div card-header>
    <b>{{'lang.deviceDetails.attributesHeadline' | translate}}</b>
  </div>
  <div card-header-more>
  </div>
  <div card-fit>
    <sb-comp-settings *ngIf="product && permissionService.hasPermission(permissionService.Permission.product_attribute_datatype_show)"
                      [product]="product" [heightPx]="340"></sb-comp-settings>
  </div>
</sb-card>
